// journalLogs.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_JOURNAL_LOGS,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Journal logs.
 * @module reducer/journalLogs
 */
const journalLogs = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_JOURNAL_LOGS:
      return _ADD_JOURNAL_LOGS(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Add journal logs
 * @kind reducer/actionType
 * @name ADD_JOURNAL_LOGS
 * @param {object} { logs } - the logs
 * @return {Immutable.Map} New state
 */
const _ADD_JOURNAL_LOGS =
  ({ logs }) =>
  state => {
    return state.mergeDeep(logs);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default journalLogs;
